import { CassiniProvider, Container, Spinner, extendTheme,withDefaultColorScheme } from '@telescope/cassini-ui';
import React, {useEffect} from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { StorageProvider } from './StorageProvider';
import { AuthProvider } from 'features';
import { FacebookLoginProvider, VoteApiProvider } from '@telescope/cassini-hooks';
import { useWidget } from '@telescope/cassini-hooks';
import { FallbackError } from 'components';
import TagManager from 'react-gtm-module';
import { baseTheme } from 'theme';
import { deepMapKeys } from 'utils';
import { getAppConfig } from '@telescope/cassini-utilities';
import { BrowserRouter as Router } from 'react-router-dom';

const { appHash, basename } = getAppConfig();

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  const { data } = useWidget();
  const { settings: authSettings } =  data.widget.global_views.auth;
  const { googleAnalytics } = data.widget.settings.general;
 

  useEffect(() => {
    TagManager.initialize({
      gtmId: googleAnalytics.gtmContainerId as string,
      dataLayer: {
        client_ga_id: googleAnalytics.gaClientMeasurementId,
        product_ga_id: googleAnalytics.gaProductMeasurementId,
        snapshot_type: data.snapshot.type,
      },
    });
  }, [
    data.snapshot.type,
    googleAnalytics.gaProductMeasurementId,
    googleAnalytics.gaClientMeasurementId,
    googleAnalytics.gtmContainerId,
  ]);

 
  const { sizes: { baseFontSize }, ...theme } = data.widget.theme;
  const themeColors = deepMapKeys(data.widget.theme.colors, (key) => (key.startsWith('_') ? key.slice(1) : key));
  const semanticTokens = {
    colors: Object.values(data.widget.theme.semanticTokens).reduce((prev: any, cur: any) => ({ ...prev, ...cur }), {}),
  };

  const widgetTheme = { ...theme, colors: themeColors, semanticTokens, baseFontSize };

  return (
    <StorageProvider prefix={`${appHash}:`}>
      <CassiniProvider
        theme={extendTheme(
          baseTheme,
          widgetTheme,
          withDefaultColorScheme({ colorScheme: widgetTheme.settings.defaultColorScheme })
        )}>      
        <React.Suspense
          fallback={
            <Container centerContent>
              <Spinner />
            </Container>
          }>
          <ErrorBoundary FallbackComponent={FallbackError}>
            <Router basename={basename}>
              <FacebookLoginProvider
                persistLogin={false}
                appId={authSettings.fbAppId}
                storagePrefix={appHash}
                isLoginEnabled={authSettings.isFacebookLoginEnabled && !!authSettings.fbAppId}>
                  <VoteApiProvider
                    settings={{
                      apiKey: data.snapshot.api_key,
                      versionId: `ssp_${data.snapshot.widget_id}_${data.snapshot.version_id}`,
                    }}>
                    <AuthProvider>
                      {children}
                    </AuthProvider>
                  </VoteApiProvider>
                </FacebookLoginProvider>
            </Router>
          </ErrorBoundary>
        </React.Suspense>
      </CassiniProvider>
    </StorageProvider>
  )
}